/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-width-scale',
  templateUrl: './theme-option-elements-chart-gauge-width-scale.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-width-scale.component.css']
})
export class ThemeOptionElementsChartGaugeWidthScaleComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_width_scale';

  constructor() {}

  receiveValue(value: number) {
    this.themeOptions.setOption(this.optionType, value / 100);
  }

}
